import 'url-search-params-polyfill';
import {db} from '../lib/observer/addObservation/db.js';
import {render} from '../lib/observer/addObservation/render.js'
import {initSelect} from '../lib/observer/addObservation/formRender.js';
import {EVENT_INIT_FORM} from '../lib/observer/addObservation/consts.js';
import {getGlobalState, setGlobalState} from '../lib/observer/addObservation/state.js';
import {selectPerson, selectSchool} from "../lib/observer/addObservation/stateUpdateHandlers.js";

initSelect(db);

const searchParams = new URLSearchParams(window.location.search);

const schoolId = searchParams.get('school');
const personId = searchParams.get('person');

if (schoolId && personId) {
  let state = getGlobalState();

  state = selectSchool(state, schoolId);
  state = selectPerson(state, personId);

  setGlobalState(state);
}

window.requestAnimationFrame(
    () => render(getGlobalState(), EVENT_INIT_FORM)
);
